module.exports = __webpack_public_path__ + "img/school-area.3670b8d.png";